<template>
    <rkm-table
        :items="localItems"
        :fields="fields.table"
        sort-by="dataReceita"
        :sort-compare="sortCompare"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="edit(item)"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click="destroy(item)"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {

            return {

                table: [
                    { label: 'Data da receita', key: 'dataReceita', sortable: true, },
                    { label: 'Médico solicitante', key: 'medicoSolicitante.cidadaoNome', sortable: true, },
                    { label: 'Medicamento', key: 'medicamento.descricao', sortable: true, },
                    { label: 'Quantidade', key: 'quantidade', sortable: true, },
                    { label: 'Ações', key: 'actions', class: 'col-min' },
                ]
            }
        }
    },
    created(){

        this.localItems = this.filteredItems()
    },
    data: () => ({
        localItems: []
    }),
    methods: {
        sortCompare(aRow, bRow, key) {

            if (key === 'dataReceita') {
                return this.parseDataBr(aRow.dataReceita) - this.parseDataBr(bRow.dataReceita)
            }

            return false
        },
        parseDataBr(data) {

            const [dia, mes, ano] = data.split('/')
            return new Date(`${ano}-${mes}-${dia}`).getTime()
        },
        edit(item) {

            this.$emit('edit', item)
        },
        destroy(item) {

            const destroy = async () => {

                const idx = this.model.medicamentosNaoPadronizados.findIndex(f => f.id == item.id)

                if (Number.isInteger(item.id)) {

                    this.$set(this.model.medicamentosNaoPadronizados[idx], 'deleted', true)

                } else {

                    this.model.medicamentosNaoPadronizados.splice(idx, 1)
                }
            }

            this.showDeleteConfirmation('Deseja realmente excluir o medicamento?', destroy)
        },
        filteredItems() {

            return this.model.medicamentosNaoPadronizados.filter(med => !med.deleted)
        }
    },
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null }
    },
    watch: {

        'model.medicamentosNaoPadronizados': {

            deep:true,
            handler() {

                this.localItems = this.filteredItems()
            }
        }
    }
}
</script>